export default "__VITE_ASSET__BzVz9FsL__"